/* eslint-disable */
// ** --- 使用介绍 ---
// * 由于 RangePickerF 使用上有些天生的缺陷，尤其在选择 结束日期时候
// * DateRangePickerF 是替代 RangePickerF 衍生出来的组件
// * Form 由父级传入 （ 必须 ）
// * 组件 id 是 FormItem 的 name
// * 数据格式 沿用 RangePickerF （ 数组格式 ）
// * 可视作为 RangePicker 的重构方案
// * 默认带有 disabledDate 互动
// * disabled 沿用 RangePickerF （ 数组格式 ）
// * rules -> validator 自定义校验，需要 父级处理
// **
import React, { useState, useEffect }  from 'react'
import { DatePicker, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import { isEqual, omit } from 'lodash'
import dayjs from 'dayjs'

const baseDay = 86499999
const DateRangePickerF = (props) => {
  const {
    id, idType,
    modalProps, picker, dateOfType,
    value, disabled,
    onChange, actionChange,
    form, gap
  } = props

   // 253402185600000 : 9999年12月31日
   const defaultValue = [
    value[0] ? dayjs(value[0]) : undefined,
    value[1] && value[1] !== 253402185600000 ? dayjs(value[1]) : undefined,
  ]

  const [ useValue, setUseValue ] = useState([
    +defaultValue[0],
    +defaultValue[1]
  ])
  const [ useError, setUseError] = useState(false)

  // onChange => form表单数据 更新
  // 参数校验
  useEffect(() => {
    if (!form) {
      console.error(`DateRangePickerF 缺少 form, 请设置 <DateRangePickerF form={form} />`)
    }
  }, [form])

  useEffect(() => {
    setUseValue([
      value[0] ? +dayjs(value[0]) : undefined,
      value[1] && value[1] !== 253402185600000 ? +dayjs(value[1]) : undefined,
    ])
  }, [value])



  // FormList 兼容 id
  const defaultId = idType === 'formList' ? id.split('_') : id


  const handleDatePicker = async(obj) => {
    const {e, eStr, dateArrIndex} = obj
    try {
      let formatValue = useValue
      switch (true) {
        case (!e): {
          formatValue.splice(dateArrIndex, 1, undefined)
          break
        }
        // dateOfType === true, 提交参数为，去除时分秒，根据picker参数
        case (dateOfType): {
          const formatConfig = {
            0: +dayjs(e).startOf(picker || 'day'),
            1: +dayjs(e).endOf(picker || 'day')
          }

          formatValue.splice(dateArrIndex, 1, formatConfig[dateArrIndex])
          break
        }
        default: {
          formatValue.splice(dateArrIndex, 1, +dayjs(e))
        }
      }

      setUseValue(formatValue)
      // 兼容FormList 方法
      // form.current.setFields([{
      //   name: defaultId,
      //   value: formatValue
      // }])
      onChange(formatValue)
      // 日期范围 限制
      // if (gap) {
      //   const [startDate, endDate] = formatValue
      //   setUseError((endDate - startDate) / baseDay + 1 > gap)
      //   //  暂时缺少 错误拦截
      //   return new Error('123')
      // }

      if (actionChange) {
        return actionChange(formatValue)
      }
      return formatValue
    } catch(err) {
      console.log('handleDatePicker', err)
    }
  }

  const disabledStartDate = (current) => {
    if (useValue[1]) {
      return current > dayjs(useValue[1])
    }
  }
  const disabledEndDate = (current) => {
    if (useValue[0]) {
      return current < dayjs(useValue[0])
    }
  }
  return (
    <>
      <DatePicker
        disabledDate={(current) => disabledStartDate(current)}
        disabled={disabled[0]}
        placeholder='开始日期'
        {...modalProps}
        defaultValue={defaultValue[0]}
        value={defaultValue[0]}
        onChange={(e, eStr) => handleDatePicker({e, eStr, dateArrIndex: 0})}
        inert
      />
      {` ~ `}
      <DatePicker
        // picker = 'week'
        // picker = 'month'
        // picker = 'quarter'
        // picker = 'year'
        // style={style}
        disabledDate={(current) => disabledEndDate(current)}
        disabled={disabled[1]}
        placeholder='结束日期'
        {...modalProps}
        defaultValue={defaultValue[1]}
        value={defaultValue[1]}
        onChange={(e, eStr) => handleDatePicker({e, eStr, dateArrIndex: 1})}
        inert
      />
    </>
  )
}
export default DateRangePickerF

DateRangePickerF.defaultProps = {
  modalProps: {},
  picker: undefined,
  disabled: [false, false],
  value: [],
  dateOfType: true
}

// ------------- 校验方法（表单提交时用） --
// const validatorDate = (rule, value) => {
//   if (!value[0]) {
//     return Promise.reject(new Error('缺少开始日期'))
//   }
//   if (!value[1]) {
//     return Promise.reject(new Error('缺少结束日期'))
//   }
//   return Promise.resolve()
// }
//
// ------------- Form事例 --
// <FormItem {...lc4} label="日期"
//   name='rangePicker'
//   rules={[{
//     required: true,
//     type: 'array',
//     validator: (rule, value) => validatorDate(rule, value)
//   }]}
// >
//   <DateRangePickerF
//     form={form}
//     modalProps={{
//       picker: 'month'
//     }}
//     actionChange={() => this.handleDateRangePickerF(item.name)}
//   />
// </FormItem>
//
// -------- actionChange -- 实时校验（表单 操作时用）
// handleDateRangePickerF = (index) => {
//   const { form } = this.props
//   const getVaue = form.current.getFieldValue('storeList')[index].rangePicker
//   const findVaue = getVaue.some( e => isNaN(e))
//   const getErr = form.current.getFieldError(['storeList', index, 'rangePicker'])
//   let err = []
//   switch (true) {
//     case !getVaue: {
//       err = ['缺少日期信息']
//       break;
//     }
//     case !getVaue[0]: {
//       err = ['缺少开始日期']
//       break;
//     }
//     case !getVaue[1]: {
//       err = ['缺少结束日期']
//       break;
//     }
//   }
//   form.current.setFields([{
//     name: ['storeList', index, 'rangePicker'],
//     errors: getErr.length === 0 ? [] : err
//   }])
// }